import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-user',
  imports: [SharedModule],
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.scss'
})
export class CreateUserComponent {
  @Input() type: 'Add' | 'Update' = 'Add';
  @Input() centers: any[] = []; // List of centers passed to the component
  @Input() clientId: string = ''; // Client ID passed from the parent component
  @Input() initialData: any; // For editing existing user
  @Input() isLoading: boolean = false;
  @Output() reload = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<void>();

  @Input() userDataToEdit: any = null; // To hold the user data to be edited

  @Input() orgId: string = ''; // Organization ID passed from the parent component
  @Input() campuses: any[] = []; // List of campuses passed to the component
  @Input() departments: any[] = []; // List of departments passed to the component
  @Input() roles: any[] = []; // List of roles passed to the component

  userForm!: FormGroup;
  submitted = false;

  genderOptions = ['Male', 'Female', 'Other'];

  // Replace these with your actual fetched data from service
  departmentOptions: any[] = [];

  roleOptions: any[] = [];

  statusOptions = ['Active', 'Inactive'];

  centerOptions: any[] = [];

  

  twoFAOptions = [
    { label: 'Enabled', value: 'True' },
    { label: 'Disabled', value: 'False' },
  ];

  constructor(private fb: FormBuilder,
    private userService: UsersService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      organization_id: [this.orgId], // Organization ID
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      gender: ['', Validators.required],
      prefix: [''],
      dept_id: [null, Validators.required],
      role_id: [null, Validators.required],
      center_id: [null, Validators.required],
      status: ['', Validators.required],
      twoFactorAuthentication: ['False', Validators.required], // Default to 'False'
      client_id : [this.clientId],
      details: ['']
    });

    console.log("departments", this.departments);
    console.log("center", this.centers);
    console.log("roles", this.roles);

    this.departmentOptions = this.departments?.map((department: any) => {
      return { label: department.dept_name, value: department.dept_id };
    }
    );
    this.centerOptions = this.centers?.map((campus: any) => {
      return { label: campus.center_name, value: campus.center_id };
    });

    this.roleOptions = this.roles?.map((role: any) => {
      return { label: role.role_name, value: role.role_id };
    });

    console.log(this.roleOptions);
    console.log(this.departmentOptions);
    console.log(this.centerOptions);

    console.log(this.departments);
    console.log(this.campuses);
    console.log(this.roles);

    if (this.type === 'Update' && this.userDataToEdit) {
      this.userForm.patchValue(this.userDataToEdit);
      // remove password field from the form if editing
      this.userForm.removeControl('password');
    }
  }

  submitForm(): void {
    this.submitted = true;

    if (this.userForm.invalid) return;

    const payload = this.userForm.value;

    this.isLoading = true; // Set loading state to true

    if (this.type === 'Update') {
      payload.user_id = this.userDataToEdit.user_id; // Add user ID for update
      this.userService.updateUser(payload).subscribe({
        next: (response) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User created successfully!' });
          this.reload.emit(); // Emit reload event to parent component
          this.handleCloseDialog(); // Close the modal after successful submission
        },
        error: (error) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create user!' });
        }
      }
      );
    } else {
      this.userService.createUser(payload).subscribe({
        next: (response) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User created successfully!' });
          this.reload.emit(); // Emit reload event to parent component
          this.handleCloseDialog(); // Close the modal after successful submission
        },
        error: (error) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create user!' });
        }
      }
      );
    }
  }

  handleCloseDialog(): void {
    this.closeModal.emit();
  }
}
